import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePaymentPage } from "../services/update-payment-page";
import { PaymentPageFormData } from "@/pages/payment-pages/types/payment-page";

export function useUpdatePaymentPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<PaymentPageFormData> }) =>
      updatePaymentPage(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-pages"] });
    },
  });
}
